export const DAILY_NAV_SETUP_TEST_IDS = {
  stepper: 'daily-nav-setup__stepper',
  step: (stepKey: string) => `daily-nav-setup__step-${stepKey}`,
  backButton: 'daily-nav-setup__back',
  nextButton: 'daily-nav-setup__next',
  noAccessAlert: 'daily-nav-setup__no-access-alert',
  notEnabledAlert: 'daily-nav-setup__not-enabled-alert',
  reportSendTime: 'daily-nav-setup-report-send-time',
  recipient: (index: number) => `daily-nav-setup__recipient-${index}`,
  addRecipient: 'daily-nav-setup-add-recipient',
  companyCounts: 'daily-nav-setup__company-counts',
  companyTable: 'daily-nav-setup__company-table',
  companyRow: (companyId: number) => `daily-nav-setup__company-row-${companyId}`,
  companySetupButton: (companyId: number) => `daily-nav-setup__company-setup-${companyId}`,
  companySetup: (companyId: number) => `daily-nav-setup__company-${companyId}`,
  includeSection: 'daily-nav-setup__include-section',
  includeSwitch: 'daily-nav-setup-include-switch',
  alexandriaSection: 'daily-nav-setup__alexandria-section',
  compsSection: 'daily-nav-setup__comps-section',
  gpcPanel: 'daily-nav-setup__gpc-panel',
  gpcApproachSelect: 'daily-nav-setup__gpc-approach-select',
  copyGpcButton: 'daily-nav-setup__copy-gpc',
  compsTable: 'daily-nav-setup__comps-table',
  companyProgress: 'daily-nav-setup__company-progress',
  startWalkthroughButton: 'daily-nav-setup__start-walkthrough',
  previousCompanyButton: 'daily-nav-setup__previous-company',
  backToCompaniesButton: 'daily-nav-setup__back-to-companies',
  saveCompanyButton: 'daily-nav-setup__save-company',
  checkingCompsNote: 'daily-nav-setup__checking-comps',
  review: 'daily-nav-setup__review',
  applyButton: 'daily-nav-setup__apply',
  applyConfirmDialog: 'daily-nav-setup__apply-confirm-dialog',
  applyConfirmButton: 'daily-nav-setup__apply-confirm',
  goToDailyNavButton: 'daily-nav-setup__go-to-daily-nav',
  goToFeatureSettingsButton: 'daily-nav-setup__go-to-feature-settings',
  contextPanelButton: 'daily-nav-setup__context-panel-button',
  contextPanel: 'daily-nav-setup__context-panel',
  contextPanelCloseButton: 'daily-nav-setup__context-panel-close',
  panelDivergenceAlert: 'daily-nav-setup__panel-divergence-alert',
  panelBehindList: 'daily-nav-setup__panel-behind-list',
  firmSaveDialog: 'daily-nav-setup__firm-save-dialog',
  firmSaveConfirmButton: 'daily-nav-setup__firm-save-confirm',
  firmSaveGroup: (stepKey: string) => `daily-nav-setup__firm-save-group-${stepKey}`,
  firmSaveEditStep: (stepKey: string) => `daily-nav-setup__firm-save-edit-${stepKey}`,
  overridesSection: 'daily-nav-setup__overrides-section',
  overrideInput: (fieldKey: string) => `daily-nav-setup__override-${fieldKey}`,
  sessionChanges: 'daily-nav-setup__session-changes',
  leaveDialog: 'daily-nav-setup__leave-dialog',
  leaveKeepEditingButton: 'daily-nav-setup__leave-keep-editing',
  leaveDiscardButton: 'daily-nav-setup__leave-discard',
  leaveSaveButton: 'daily-nav-setup__leave-save',
  incompleteStepAlert: 'daily-nav-setup__incomplete-step-alert',
  incompleteStepButton: 'daily-nav-setup__incomplete-step-button',
  reviewSetUpCompanyButton: (companyId: number) => `daily-nav-setup__review-set-up-${companyId}`,
  removeCompButton: (capIqId: string) => `daily-nav-setup__remove-comp-${capIqId}`,
  resetOverrideButton: (fieldKey: string) => `daily-nav-setup__reset-override-${fieldKey}`,
  removeRecipientButton: (index: number) => `daily-nav-setup__remove-recipient-${index}`,
  setupLoadingIndicator: 'daily-nav-setup__setup-loading',
  setupErrorAlert: 'daily-nav-setup__setup-error',
  companyConfigErrorAlert: 'daily-nav-setup__company-config-error',
  companyConfigRetryButton: 'daily-nav-setup__company-config-retry',
  resumeBanner: 'daily-nav-setup__resume-banner',
  resumeButton: 'daily-nav-setup__resume-button',
} as const;
